import styled from 'styled-components';

export const TEXT = styled.span`
	text-align: justify;
	line-height: initial;
	text-indent: 2em;
	margin-top: 10px;
`;
